import React, { useEffect } from 'react';
import { usePerformanceMonitoring } from '../hooks/usePerformanceMonitoring';

const PerformanceMonitor = ({ children }) => {
  usePerformanceMonitoring();

  useEffect(() => {
    // Monitor long tasks
    if ('PerformanceObserver' in window) {
      try {
        const observer = new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            if (entry.duration > 50) {
              console.warn('[Long Task]', {
                duration: entry.duration,
                startTime: entry.startTime,
                name: entry.name
              });
            }
          }
        });
        observer?.observe({ entryTypes: ['longtask'] });

        return () => observer?.disconnect();
      } catch (e) {
        // PerformanceObserver not supported for longtask
      }
    }
  }, []);

  return <>{children}</>;
};

export default PerformanceMonitor;